import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { webUrlNode } from "../../../constants/appInfo";
function Field({ label, children }) {
  return (
    <div style={styles.field}>
      <label style={styles.label}>{label}</label>
      <div style={styles.inputWrapper}>
        {children}
      </div>
    </div>
  );
}
export default function CreateBatchPopup({
  open,
  onClose,
 
  onCreated
}) {

  const [form, setForm] = useState({
    batchName: "",
    startDate: "",
    endDate: "",
    mode: "live",
    maxStudents: "",
    price: ""
  });   const coursePostId = useSelector((state)=>state?.course?.course?.postId);
          const currentToken = useSelector((state)=>state?.user?.user?.token);
               const userEmail = useSelector((state)=>state?.user?.user?.user_email);

       const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!open) return null;

  function setField(name, value) {
    setForm(prev => ({ ...prev, [name]: value }));
  }

  async function submit() {

    if (!form.batchName) {
      setError("Batch name is required");
      return;
    }

    setLoading(true);
    setError("");

    try {

      const res = await axios.post(`${webUrlNode}/api/batches/create?appToken=${AppToken}`, {
        coursePostId, 
       

        batchName: form.batchName,
        startDate: form.startDate || null,
        endDate: form.endDate || null,
        mode: form.mode,
        maxStudents: form.maxStudents
          ? Number(form.maxStudents)
          : null,
        price: form.price
          ? Number(form.price)
          : 0},{
       params:{
        currentToken}
      });

      if (onCreated) {
        onCreated(res.data);
      }

      onClose();

    } catch (e) {
      console.error(e);
      setError("Failed to create batch");
    } finally {
      setLoading(false);
    }
  }

  

  return (
  <div style={styles.overlay}>
      <div style={styles.modal}>
<div style={{width:"85%",
    maxWidth: 650,}}>
        <div style={styles.header}>
          <h1 style={{ margin: 0 }}>Create Batch</h1>
        </div>

        {error && (
          <div style={styles.error}>
            {error}
          </div>
        )}

        <div style={styles.grid}>

          {/* Batch Name */}
          <Field label="Batch Name">
            <input
             style={{border:"2px solid rgba(144, 202, 249,1)",padding:"10px 15px",borderRadius:"15px",color:"#222222",outline:0}}
              type="text" placeholder="Morning Batch 1"
              value={form.batchName}
              onChange={e =>
                setField("batchName", e.target.value)
              }
            />
          </Field>

          {/* Mode */}
          <Field label="Mode">
            <select
             style={{border:"2px solid rgba(144, 202, 249,1)",padding:"10px 15px",borderRadius:"15px",color:"#222222",outline:0}}
              value={form.mode}
              onChange={e =>
                setField("mode", e.target.value)
              }
            >
              <option value="live">Live</option>
              <option value="recorded">Recorded</option>
              <option value="hybrid">Hybrid</option>
            </select>
          </Field>

          {/* Start */}
          <Field label="Start Date">
            <input  placeholder="Batch Start Date"
             style={{border:"2px solid rgba(144, 202, 249,1)",padding:"10px 15px",borderRadius:"15px",color:"#222222",outline:0}}
              type="datetime-local"
              value={form.startDate}
              onChange={e =>
                setField("startDate", e.target.value)
              }
            />
          </Field>

          {/* End */}
          <Field label="End Date">
            <input  placeholder="Batch End Date"
            style={{border:"2px solid rgba(144, 202, 249,1)",padding:"10px 15px",borderRadius:"15px",color:"#222222",outline:0}}
              type="datetime-local"
              value={form.endDate}
              onChange={e =>
                setField("endDate", e.target.value)
              }
            />
          </Field>

          {/* Max Students */}
          <Field label="Max Students">
            <input  placeholder="Add max Students"
             style={{border:"2px solid rgba(144, 202, 249,1)",padding:"10px 15px",borderRadius:"15px",color:"#222222",outline:0}}
              type="number"
              value={form.maxStudents}
              onChange={e =>
                setField("maxStudents", e.target.value)
              }
            />
          </Field>

          {/* Price */}
          <Field label="Price (₹)">
            <input  placeholder="Price  (₹) "
            style={{border:"2px solid rgba(144, 202, 249,1)",padding:"10px 15px",borderRadius:"15px",color:"#222222",outline:0}}
              type="number"
              value={form.price}
              onChange={e =>
                setField("price", e.target.value)
              }
            />
          </Field>

        </div>

        <div style={styles.footer}>
          <button
            style={styles.cancelBtn}
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            style={styles.primaryBtn}
            onClick={submit}
            disabled={loading}
          >
            {loading ? "Creating..." : "Create Batch"}
          </button>
        </div>
</div>
      </div>
    </div>
  );
}

/* ---------------- styles ---------------- */

const styles = {
  overlay: {
    position: "fixed",zIndex:9999999,
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",overflowY:"auto",
    justifyContent: "center",
    padding: 16,
  },

  modal: {
    background: "#fff",position:"absolute",
    borderRadius: 16,top:"5px",bottom:"5px",
    padding: 24,display:"flex",justifyContent:"center",alignItems:"center",
   width:"100%",
    maxWidth: 650,
    boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
    fontFamily: "Inter, sans-serif"
  },

  header: {
    marginBottom: 20
  },

  error: {
    background: "#fee2e2",
    color: "#b91c1c",
    padding: "8px 12px",
    borderRadius: 8,
    fontSize: 13,
    marginBottom: 15
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: 16
  },

  field: {
    display: "flex",padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",
    flexDirection: "column"
  },

  label: {
    fontSize: 13,
    fontWeight: 600,
    marginBottom: 6,
    color: "#475569"
  },

  inputWrapper: {
    display: "flex"
  },
 

  footer: {
    marginTop: 24,
    display: "flex",
    justifyContent: "flex-end",
    gap: 10
  },

  cancelBtn: {
    padding: "12px 14px",
    borderRadius: 8,
    border: "1px solid #e5e7eb",
    background: "#fff",
    cursor: "pointer"
  },

  primaryBtn: {
    padding: "12px 16px",
    borderRadius: 8,
    border: "none",
    background: "rgba(144, 202, 249,1)",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer"
  }
};